<template>
  <b-modal
    v-model="isShow"
    :title="data?.PaymentCode ? $t('ar_client_edit_bill') : $t('ar_client_create_bill')"
    centered

    dialog-class="d-class"
  >
    <validation-observer ref="formRef">
      <b-row class="w-100 p-1 m-0">
        <b-col md="12">
          <validation-provider
            #default="{ errors }"
            rules="required"
            :name="$t('ar_client_company')"
          >
            <b-form-group :label="$t('ar_client_company') + ':'" class="label-requires">
              <WidgetSelect
              :errors="errors"
                :customOptions="
                  (options) =>
                    options.map((option) => ({
                      ...option,
                      CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
                    }))
                "
                :disabled="readOnly"
                label="CodeName"
                placeholder="ar_voucher_select_company"
                v-model="valSelectCompany"
                :dataSource="arClient.api_AR_RCL01"
                :dataSourceParams="{
                  IsCheckPermission:false
                }"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col md="6" class="mb-2">
          <validation-provider
            #default="{ errors }"
            rules="required|max:100"
            :name="$t('ar_client_payer')"
          >
            <b-form-group :label="$t('ar_client_payer') + ':'" class="label-requires">
              <b-form-input  :state="errors.length > 0 ? false : null" :disabled="readOnly" v-model="submitterVal"></b-form-input>
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <validation-provider :name="$t('ar_clinent_create_code_payment')">
            <div class="d-flex align-items-center mt-3">
              <label class="mr-2">{{ $t("ar_client_auto_create_payment_code") }}</label>
              <b-form-checkbox
                :disabled="data?.PaymentCode"
                v-model="isAutoCreateCode"
                switch
              ></b-form-checkbox>
            </div>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="{ errors }"
            rules="required|max:100"
            :name="$t('ar_client_payment_date')"
          >
            <b-form-group :label="$t('ar_client_payment_date')" class="label-requires">
              <date-range-picker
              :clearable="false"
                v-if="data?.TotalAmount <= 0 || !data?.PaymentDate"
                :max-date="dayjs().endOf('day')"
                v-model="dateOfFiling"
                :single-date-picker="true"
                opens="right"
                :ranges="false"
                :time-picker="true"
                :time-picker-increment="1"
                :show-dropdowns="true"
                :auto-apply="false"
                :locale-data="
                  isViLanguage
                    ? {
                        format: 'dd/mm/YYYY',
                        daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
                        monthNames: [
                          'Tháng 1',
                          'Tháng 2',
                          'Tháng 3',
                          'Tháng 4',
                          'Tháng 5',
                          'Tháng 6',
                          'Tháng 7',
                          'Tháng 8',
                          'Tháng 9',
                          'Tháng 10',
                          'Tháng 11',
                          'Tháng 12',
                        ],
                        firstDay: 0,
                      }
                    : undefined
                "
              />
              <b-form-input
                v-else
                :disabled="true"
                :value="dayjs(dateOfFiling).format('DD/MM/YYYY')"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            :rules="{ code: !isAutoCreateCode, required: !isAutoCreateCode, max: 13,min:2 }"
            :name="$t('ar_client_payment_code')"
          >
            <b-form-group class="label-requires" :label="$t('ar_client_payment_code') + ':'">
              <WidgetCleave
                :errors="errors /* .length > 0 ? errors : duplicateCodeMessages[0] */"
                type="uppercase"
                :disabled="data?.PaymentCode || isAutoCreateCode"
                v-model="paymentCode"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] /* || duplicateCodeMessages[0] */ }}</small>
          </validation-provider>
        </b-col>
        <b-col md="12">
          <validation-provider
            #default="{ errors }"
            rules="max:255"
            :name="$t('ar_client_account_note')"
          >
            <b-form-group :label="$t('ar_client_account_note')">
              <b-form-textarea :rows="6" v-model="note"></b-form-textarea>
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
    <!--  <validation-observer ref="formRef">
      <div class="row p-3">
        <FormItems :items="items" />
      </div>
    </validation-observer> -->
    <template #modal-footer="">
      <LoadingModalButton :usingTimeOutSubmit="true" ref="buttonRef" @click="acceptDataAddVoucher">
        {{ $t("ar_common_save") }}
      </LoadingModalButton>
    </template>
  </b-modal>
</template>
<style scss>
.d-class {
  max-width: 550px;
}
</style>
<script>
import LoadingModalButton from "../../ultils/Button/LoadingModalButton.vue";
import { arClient } from "@/api/ar-client";
import FormItems from "../../ultils/Form/FormItems.vue";
import WidgetCleave from "../../ultils/Form/components/Cleave/WidgetCleave.vue";
import WidgetSelect from "../../ultils/Form/components/Select/WidgetSelect.vue";

import { required } from "@validations";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: {
    billErrorCode: String,
    isShow: {
      type: Boolean,
      default: false,
    },
    /*  listCompany: Array, */
    data: {
      type: Object,
      default: null,
    },
  },
  components: {
    LoadingModalButton,
    WidgetSelect,
    WidgetCleave,
    FormItems,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      duplicateCodeMessages: [],
      duplicateValue: "",
      required,
      listCompany: [],

      valSelectCompany: null,
      dateOfFiling: this.getUTC("start", "day"),
      isAutoCreateCode: false,
      submitterVal: null,
      paymentCode: null,
      note: "",
    };
  },

  methods: {
    acceptDataAddVoucher() {
      this.$refs.formRef.validate().then((success) => {
        if (success) {
          this.$refs.buttonRef.startLoading()
          const data = {
            AutoCode: this.isAutoCreateCode,
            PaymentCode: this.paymentCode,
            Payer: this.submitterVal,
            Note: this.note,
            ArTravelAgentId: this.valSelectCompany,
            PaymentDate: this.dayjs(this.dateOfFiling).format(),
          
          };
          if (this.data !== null) {
            this.$emit("accept-data-edit", data, this.data.Id);
            return;
          }
          this.$emit("accept-data", data);
        }
      });
    },
    refillDataEdit() {
      if (this.data) {
        this.valSelectCompany = this.data.ArTravelAgentId
        this.isAutoCreateCode = this.data.IsAutoGeneration
        this.paymentCode = this.data.PaymentCode;
        this.submitterVal = this.data.Payer;
        this.note = this.data.Note;
        this.dateOfFiling = this.data.PaymentDate;
      }
    },

    clearValueInput() {
      this.duplicateCodeMessages = "";

      this.valSelectCompany = null;
      this.dateOfFiling = this.getUTC("start", "day");
      this.isAutoCreateCode = false;
      this.submitterVal = null;
      this.paymentCode = null;
      this.note = "";
      this.data = null;
    },
  },

  computed: {
    readOnly() {
      return this.data?.DistributionStatus === "FULL" || this.data?.TotalAmount > 0;
    },
  },
  watch: {
    billErrorCode(value) {
      if (value === "E.AR_IPA01.C01") {
        this.duplicateValue = this.paymentCode;
        this.duplicateCodeMessages.push(this.$t("ar_client_duplicate_code"));
      }
    },
    paymentCode(value) {
      if (value === this.duplicateValue) {
        this.duplicateCodeMessages.push(this.$t("ar_client_duplicate_code"));
      } else {
        this.duplicateCodeMessages = [];
      }
    },
    isShow(value) {
      this.$emit("update:isShow", value);
      if (value) {
        this.refillDataEdit();
        return;
      }
      setTimeout(() => {
        if(!this.data?.PaymentCode){

          this.clearValueInput();
        }
      }, 300);
    },
    isAutoCreateCode(value) {
      if (value && !this.data?.PaymentCode) {
        this.paymentCode = null;
      }
    },
    /*  valSelectCompany(value) {
      if (!this.isAutoCreateCode) {
        return;
      }

      this.paymentCode =
        value.ClientCode + "_" + Math.floor(Math.random() * 100);
    }, */
  },
  created(){
    console.log(this.dayjs(new Date()).add("10","s").format("DD-MM-YYYY HH:mm:ss"),"2944")
  }
};
</script>
